import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  grid7: {
    display: 'grid',
    gridAutoRows: '1fr',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  cells: {
    flex: '1 0 auto',
  },
  weekDay: {
    margin: '1.2em 2em',
    textAlign: 'center',
    color: theme.palette.text.disabled,
    letterSpacing: 0.25,
  },
}))

export default useStyles
